






















import { Component, Vue, Watch } from "vue-property-decorator";
import Store from "@/store/store";
import axios from "axios";
import moment from "moment";
import { JobItem } from "../../common/interfaces";
import JobListItem from "./JobListItem.vue";

@Component({
  components: {
    JobListItem
  }
})
export default class JobList extends Vue {
  protected searchTerm: string = "";
  protected collapsed: boolean = false;
  protected loadingJobs: boolean = true;
  protected jobList: JobItem[] = [];

  protected async mounted() {
    this.GetJobList();
    this.$root.$on("refreshJobList", this.GetJobList);
  }

  protected async GetJobList() {
    this.loadingJobs = true;
    this.jobList = [];
    const response = await axios.get(
      `${Store.state.Environment.ODataBaseUrl}/Problems/?$select=ProblemId,Description,Type1Id,StatusId,StatusFlag` +
        `&$expand=ProblemXtra($select=EngineerCode,BookedInDateTime,JobDate),` +
        `Contact($select=ContactId;$expand=Division($select=Name;$expand=Company($select=Name))` +
        `),Inventory($select=InventoryId;` +
        `$expand=Division($select=DivisionId,Name;$expand=Address($select=AddressLine4,Postcode)` +
        `,Company($select=CompanyId,Name))` +
        `,InventoryXtra($select=NextVisitDate)),Type1($select=Description)` +
        `&$filter=StatusId eq 'ENGINR' and StatusFlag eq 'A' and ProblemXtra/EngineerCode eq '${Store.state.User.UserCode}'`,
      {
        headers: {
          Authorization: "Bearer " + Store.state.User.AccessToken
        }
      }
    );
    if (response.status === 200 && response.data) {
      const jobs = response.data.value;
      jobs.forEach((j: any) => {
        let addressPostcode = "";
        if (j.Inventory.Division) {
          const postcode = j.Inventory.Division.Address.Postcode;
          const addressLine4 = j.Inventory.Division.Address.AddressLine4;
          if (addressLine4 !== "") {
            addressPostcode = `${addressLine4} ${postcode}`;
          } else {
            addressPostcode = postcode;
          }
        }
        const job: JobItem = {
          JobId: j.ProblemId,
          JobDescription: j.Description,
          JobType: j.Type1Id,
          TypeDescription: j.Type1.Description,
          StatusId: j.StatusId,
          StatusFlag: j.StatusFlag,
          EngineerCode: j.ProblemXtra.EngineerCode,
          BookedInDateTime: j.ProblemXtra.BookedInDateTime
            ? moment(j.ProblemXtra.BookedInDateTime)
            : undefined,
          DivisionName: j.Inventory ? j.Inventory.Division.Name : null,
          CompanyName: j.Inventory ? j.Inventory.Division.Company.Name : null,
          AddressPostcode: addressPostcode,
          NextVisitDate: moment(j.Inventory.InventoryXtra.NextVisitDate),
          ContactId: j.Contact ? j.Contact.ContactId : null,
          DueDate:
            j.ProblemXtra && j.ProblemXtra.JobDate
              ? moment(j.ProblemXtra.JobDate)
              : null
        };

        this.jobList.push(job);
      });
      this.loadingJobs = false;
    }
  }

  protected toggleAside() {
    this.collapsed = !this.collapsed;
  }

  get filteredJobList() {
    return this.jobList
      .filter((j: JobItem) => {
        const term = this.searchTerm.toUpperCase();
        return (
          j.JobId.toString().includes(term) ||
          (j.JobDescription && j.JobDescription.toUpperCase().includes(term)) ||
          (j.CompanyName && j.CompanyName.toUpperCase().includes(term)) ||
          (j.DivisionName && j.DivisionName.toUpperCase().includes(term))
        );
      })
      .sort((a: JobItem, b: JobItem): number => {
        if (!a.BookedInDateTime || !a.BookedInDateTime!.isValid()) {
          return 1;
        } else if (!b.BookedInDateTime || !b.BookedInDateTime!.isValid()) {
          return -1;
        } else {
          return a.BookedInDateTime!.diff(b.BookedInDateTime);
        }
      });
  }
}
